<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <contactBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import contactBannerComponent from '../contact/contactBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    contactBannerComponent,
    footerComponent,
  },
};
</script>
